import { render, staticRenderFns } from "./BasketList.vue?vue&type=template&id=278dff55"
import script from "./BasketList.vue?vue&type=script&lang=js"
export * from "./BasketList.vue?vue&type=script&lang=js"
import style0 from "./BasketList.vue?vue&type=style&index=0&id=278dff55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports